import type { IDevPanelMockField } from './DevPanel.types';

interface IParsedMockFields {
    values?: Record<string, unknown>;
    error?: string;
}

export const stringifyStoredMock = (value: unknown): string => {
    if (value === null || value === undefined) {
        return '';
    }
    return JSON.stringify(value, null, 2);
};

const parseJsonField = (raw: string, label: string): { value?: unknown; error?: string } => {
    const trimmed = raw.trim();
    if (trimmed === '') {
        return {};
    }
    try {
        return { value: JSON.parse(trimmed) };
    } catch {
        return { error: `${label} is not valid JSON` };
    }
};

export const parseFields = (
    fields: ReadonlyArray<IDevPanelMockField>,
    values: Record<string, string>,
): IParsedMockFields => {
    const parsed: Record<string, unknown> = {};
    const error = fields
        .map((field) => {
            let raw = values[field.id];
            if (raw === undefined) {
                raw = '';
            }
            const result = parseJsonField(raw, field.label);
            if (result.error !== undefined) {
                return result.error;
            }
            if (result.value !== undefined) {
                parsed[field.id] = result.value;
            }
            return undefined;
        })
        .find((fieldError) => fieldError !== undefined);

    if (error !== undefined) {
        return { error };
    }
    return { values: parsed };
};
